import React, { Component } from 'react'

class MaintenanceMode extends Component {
  render() {
    return <>
      <h1>Site internet en cours de construction</h1>
      <h1>Website wird derzeit überarbeitet</h1>
      <h1>Website currently under construction</h1>
    </>
  }
}

export default (component) => {
  if (window.maintenanceMode || process.env.REACT_APP_MAINTENANCE) {
    return MaintenanceMode
  }
  return component;
}